import {
  SET_RAFFLE_RENDERER
} from 'Store/constants';

const initialState = {
  isWebView: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_RAFFLE_RENDERER:
      return { ...state, isWebView: true };
    default:
      return state;
  }
};
